import React, { useState } from "react";
import logo from '../logo.svg';
import { Link, useParams } from "react-router-dom";

const NotAvailable = () => {
const { cityName } = useParams();
const formattedCityName = cityName ? cityName.replace(/-/g, " ") : "your city";
const displayCityName = formattedCityName.toLowerCase() === "greensboro" ? "Greensboro, NC" : formattedCityName;
const [phoneNumber, setPhoneNumber] = useState("");
const [showInitialContent, setShowInitialContent] = useState(true);
const [showMessage, setShowMessage] = useState(false);
const [showError, setShowError] = useState(false);

// Format phone number as (XXX) XXX-XXXX
const formatPhoneNumber = (value) => {
const digits = value.replace(/\D/g, "");
if (digits.length <= 10) {
if (digits.length <= 3) return `(${digits}`;
if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}
return phoneNumber;
};

// Handle phone number input
const handlePhoneChange = (e) => {
const value = e.target.value;
const digits = value.replace(/\D/g, "");
if (digits.length <= 10) {
setPhoneNumber(formatPhoneNumber(value));
}
};

// Handle signup button click
const handleSignUpClick = () => {
const phoneDigits = phoneNumber.replace(/\D/g, "");
if (phoneDigits.length === 10) {
setShowInitialContent(false);
setShowMessage(true);
setTimeout(() => {
setShowError(true);
}, 2000);
}
};

// Handle error message click to reset
const handleErrorClick = () => {
setShowMessage(false);
setShowError(false);
setShowInitialContent(true);
setPhoneNumber("");
};

return (
<>
<style>
{`
.city-page {
display: flex;
min-height: 100vh;
font-family: 'Poppins', sans-serif;
background-color: #FEF4F5;
overflow-x: hidden;
}

.city-left {
width: 40%;
padding: 40px;
display: flex;
flex-direction: column;
justify-content: center;
position: relative;
transition: transform 0.8s ease;
}

.city-logo {
margin-bottom: 30px;
text-align: center;
}

.city-logo img {
width: 100px;
height: auto;
}

.city-logo .logo-underline {
width: 60px;
height: 3px;
background-color: #fd5c63;
margin: 10px auto;
}

.city-content {
max-width: 400px;
margin: 0 auto;
text-align: left;
}

.city-content h1 {
font-size: 38px;
font-weight: 700;
color: #1a1a1a;
margin-bottom: 20px;
text-transform: capitalize;
line-height: 1.2;
}

.city-content h4 {
font-size: 20px;
font-weight: 600;
color: #333;
margin-bottom: 16px;
}

.city-content p {
font-size: 16px;
color: #666;
line-height: 1.6;
margin-bottom: 24px;
}

.input-container {
display: flex;
flex-direction: column;
gap: 0px;
max-width: 100%;
}

.input-container input {
padding: 18px;
font-size: 12px;
border-radius: 8px;
border: 1px solid #ddd;
width: 100%;
box-sizing: border-box;
outline: none;
transition: border-color 0.3s, box-shadow 0.3s;
}

.input-container input:focus {
border-color: #fd5c63;
box-shadow: 0 0 8px rgba(253, 92, 99, 0.2);
}

.input-container button {
padding: 18px;
font-size: 12px;
font-weight: 600;
color: #ffffff;
background-color: #fd5c63;
border: none;
border-radius: 8px;
cursor: pointer;
text-transform: uppercase;
transition: background-color 0.3s, transform 0.2s;
}

.input-container button:hover {
background-color: #e04e56;
transform: translateY(-2px);
}

.city-right {
width: 60%;
position: relative;
overflow: hidden;
clip-path: circle(80% at 90% 50%);
}

.city-right img {
width: 120%;
height: 100%;
object-fit: cover;
transition: transform 0.3s ease;
}

.city-right img:hover {
transform: scale(1.05);
}

.city-right::before {
content: '';
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: rgba(253, 92, 99, 0.1);
pointer-events: none;
}

.slide-left {
animation: slideLeft 0.8s ease forwards;
}

@keyframes slideLeft {
from {
transform: translateX(0);
opacity: 1;
}
to {
transform: translateX(-50%);
opacity: 0;
}
}

.message-container {
position: absolute;
top: 50%;
left: 25%;
transform: translateY(-50%);
text-align: left;
animation: slideIn 0.8s ease forwards;
}

@keyframes slideIn {
from {
transform: translateY(-50%) translateX(50%);
opacity: 0;
}
to {
transform: translateY(-50%) translateX(0);
opacity: 1;
}
}

.message {
font-size: 26px;
font-weight: 700;
color: #1a1a1a;
margin-bottom: 12px;
}

.processing {
font-size: 18px;
color: #666;
margin-bottom: 12px;
}

.error {
font-size: 16px;
color: #fd5c63;
background-color: #ffffff;
padding: 10px 20px;
border-radius: 8px;
cursor: pointer;
transition: color 0.3s;
box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.error:hover {
color: #fd5c63;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
.city-page {
flex-direction: column;

}

.city-left {
width: 100%;
padding: 24px;

}

.city-right {
display: none;
}

.city-content {
max-width: 100%;

}

.city-content h1 {
font-size: 28px;
}

.city-content h4 {
font-size: 18px;
}

.city-content p {
font-size: 14px;
}

.input-container {
gap: 0px;
}

.input-container input,
.input-container button {
padding: 16px;
font-size: 13px;
}
.error {
font-size: 14px;
padding: 15px 16px;
border-radius: 6px;
width: 80%;
box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
margin-left: auto;
margin-right: auto;
text-align: center;
}

.error:hover {
color: #fd5c63;
}
.message-container {
position: static;
transform: none;
text-align: center;
margin-top: 190px;
}
}
`}
</style>

<div className="city-page">
<div className={`city-left ${!showInitialContent && showMessage ? 'slide-left' : ''}`}>
<div className="city-logo">
<Link to="/">
<img src={logo} alt="Berymo Logo" />
</Link>
<div className="logo-underline"></div>
</div>
<div className="city-content">
{showInitialContent && (
<>
<h1>Get Ready for<br />{displayCityName}!</h1>
<h4>Join the Adventure</h4>
<p>
Drop your phone number to be the first to know when Berymo Places launches in <strong>{displayCityName.toUpperCase()}</strong>!
</p>
<div className="input-container">
<input
type="tel"
placeholder="Phone Number (e.g., (123) 456-7890)"
value={phoneNumber}
onChange={handlePhoneChange}
/>
<button onClick={handleSignUpClick}>Join the Waitlist</button>
</div>
</>
)}
</div>
</div>

<div className="city-right">
<img
src="/images/rider-overview-general.jpg"
alt="Berymo Celebration"
onError={(e) => (e.target.src = "/images/fallback.jpg")}
/>
</div>

{showMessage && (
<div className="message-container">
<div className="message">Ride Free with Berymo!</div>
<div className="processing">Processing your request...</div>
{showError && (
<div className="error" onClick={handleErrorClick}>
I didn't receive a text
</div>
)}
</div>
)}
</div>
</>
);
};

export default NotAvailable;
